<h2 mat-dialog-title>{{ data.columnName }} imported values</h2>

<mat-dialog-content>
  <div *ngIf="hasTooManyValues" class="csv-warning">
    Too many values were added for this selection. Maximum allowed is
    {{ data.maxValues }} values. Please reduce the list.
  </div>

  <div *ngIf="hasValues" class="csv-summary">
    Total imported values: {{ data.values.length }}
  </div>

  <div *ngIf="!hasValues" class="csv-empty">No values imported from CSV.</div>

  <div *ngIf="hasValues" class="csv-table-container">
    <ngx-datatable
      class="my-table material product-search fixed-header striped shadow-none animation-fade-in custom-ngx-datatable csv-values-datatable"
      [rows]="rows"
      [columnMode]="'force'"
      [headerHeight]="50"
      [footerHeight]="0"
      [rowHeight]="40"
      [scrollbarV]="true"
      [scrollbarH]="true"
    >
      <ngx-datatable-column
        name="#"
        [width]="60"
        [minWidth]="60"
        [maxWidth]="60"
        [sortable]="false"
        [resizeable]="true"
        [canAutoResize]="false"
        [headerTemplate]="headerTpl"
      >
        <ng-template ngx-datatable-cell-template let-rowIndex="rowIndex">
          <div class="csv-index-cell">
            {{ rowIndex + 1 }}
          </div>
        </ng-template>
      </ngx-datatable-column>

      <ngx-datatable-column
        [name]="data.columnName"
        [sortable]="false"
        [resizeable]="true"
        [canAutoResize]="true"
        [flexGrow]="1"
        [headerTemplate]="headerTpl"
      >
        <ng-template ngx-datatable-cell-template let-row="row">
          <div class="csv-value-cell" [title]="row.value">
            {{ row.value }}
          </div>
        </ng-template>
      </ngx-datatable-column>
    </ngx-datatable>
  </div>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-button type="button" (click)="close()">Close</button>
</mat-dialog-actions>

<ng-template #headerTpl let-column="column">
  <div class="header-resizeable">{{ column.name }}</div>
</ng-template>
